import { Component } from '@angular/core';

@Component({
  selector: 'cad-public',
  templateUrl: './public-layout.component.html',
})
export class PublicLayoutComponent {}
